// removed by extract-text-webpack-plugin
module.exports = {"site-footer":"site-footer__13qVb","copyright":"copyright__TzTmu"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/Footer/styles.scss
// module id = ./app/scripts/views/App/components/Footer/styles.scss
// module chunks = 1